import { Component, AfterViewInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html'
})
export class NotfoundComponent implements AfterViewInit {

  constructor(private _location: Location) { }

  ngAfterViewInit() { }

  backClicked() {
    this._location.back();
  }
 
}
